import { useTranslation } from "react-i18next";
import { ToggleSwitch } from "./ToggleSwitch";
import DatePicker, { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale"
import { ActivityFilters } from "../types";


export function ActivityFilter({filters, onFiltersChange}: {filters: ActivityFilters, onFiltersChange: (newFilters: Partial<ActivityFilters>) => void}) {
  const { t, i18n } = useTranslation();
  
  registerLocale("fr", fr);

  function toggleChecked(checked: boolean) {
    onFiltersChange({my_activity: checked});
  }

  function dateRangeChanged(dates: [Date | any, Date | any]){
    onFiltersChange({date_from: dates[0], date_to: dates[1]})
  }

  return (
    <div className="filters row">
      <div className="col">
        <ToggleSwitch checked={filters.my_activity}
          toggleChecked={(checked) => {
            toggleChecked(checked);
          }}
        />
      </div>
      <div className="col">
        <DatePicker
          selectsRange={true}
          startDate={filters.date_from}
          endDate={filters.date_to}
          onChange={(update) => {
            dateRangeChanged(update)
          }}
          customInput={<button className="btn">{t('select_period')}</button>}
          locale={i18n.language}
        />
      </div>
    </div>
  )
}